import styled from "styled-components";
import { MainBodyText, MainBodyTextColumn, MainFindOutMore, MainHeadingCapital, MainHeadingColumn, MainHeadingGrey, MainBlock, MainSection, MainWrapper, MainHeadingBlock, } from "../../../components/01_config/MainStyles"
import { sizes } from "../../../components/01_config/Sizes";

const Wrapper = styled(MainSection)`

`

const FirstBlock = styled.div`
    flex: 1;
    height: 40vw;
    margin-top: 40px;
    @media(max-width: 800px) {
        margin-top: 0px;
    }
`

const SecondBlock = styled(FirstBlock)`
    margin-top: 0px;
`

const ImageWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 70%;
    left: -10px;
`

const Image = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`

const FirstTextBox = styled.div`
    position: relative;
    box-sizing: border-box;
    width: 100%;
    margin-top: -20px;
    padding: 40px 20px 20px 20px;
    right: -10px;
    background-color: #EBEBEB;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 10px;
    text-align: right;
    z-index: -10;
`

const SecondTextBox = styled(FirstTextBox)`
    background-color: #D1D1D1;
`

const ThirdBlock = styled(MainBlock)`
    margin-top: 40px;
    height: fit-content;
    gap: 25px;
    @media(max-width: 800px) {
        margin-top: 0px;
    }
`

const HeadingCapital = styled(MainHeadingCapital)`
    
`


const BodyText = styled(MainBodyTextColumn)`
    font-size: 1rem;
`

const WhoWeAre = styled(MainHeadingGrey)`
    color: grey;
    @media(max-width: 800px) {
        font-size: calc(12px + 1.5vw);
    }
`

const Heading = styled(MainHeadingBlock)`
`
const BodyTextLastBlock = styled(MainBodyText)`
`

const FindOutMore = styled(MainFindOutMore)`

`


export { Wrapper, FirstBlock, SecondBlock, ThirdBlock, ImageWrapper, Image, FirstTextBox, SecondTextBox, Heading, BodyText, WhoWeAre, HeadingCapital, BodyTextLastBlock, FindOutMore }